<script setup lang="ts">
import { fetchAddReadCountByLog, fetchTopicJson } from './apis/api';
import { browerVersion, getUrlQuery, initYoumeng } from './utils';
import useWxShareStore from './store/wxShare';

const emptyPage = import.meta.env.VITE_EMPTY_PAGE;
const version = browerVersion();
const { height: windowHeight } = useWindowSize();
const topicParams = reactive({ year: '', month: '', date: '', topicId: '' });
const containerwidth = computed(() => {
  if (!version.mobile) {
    return `${Math.ceil(windowHeight.value * 0.5625)}px`;
  }
  return '100vw';
});
const headerImageHeight = computed(() => {
  if (!version.mobile) {
    return `${Math.ceil(windowHeight.value * 0.5625 * 0.5)}px`;
  }
  return '50vw';
});

const wxShareStore = useWxShareStore();
const headerImage = ref(import.meta.env.VITE_DEFAULT_IMAGE_16_9);
const topicTitle = ref('');
const topicChannels = ref<{ id: string; name: string; topicId: string }[]>();
const hasChild = ref(false);
/**
 * 获取专题详情
 */
const getTopicDetail = async () => {
  try {
    const res = await fetchTopicJson(
      topicParams.year,
      topicParams.month,
      topicParams.date,
      topicParams.topicId,
    );
    const { title, description, mSharePic, mCoverImg, mCoverImg1, timeTheme } =
      res.topicDetail;
    wxShareStore.initWxShare({
      title,
      desc: description || title,
      imgUrl: mSharePic,
    });
    hasChild.value = res.isHasChild;
    topicTitle.value = title;
    document.title = title;
    const bodyDom = document.body;
    let themeClass = bodyDom.className;
    if (!import.meta.env.DEV) {
      switch (Number(timeTheme)) {
        case 1:
          themeClass = 'blue-theme';
          break;
        case 2:
          themeClass = 'red-theme';
          break;
        case 3:
          themeClass = 'yellow-theme';
          break;
        case 4:
          themeClass = 'brown-theme';
          break;
        case 5:
          themeClass = 'olympic-theme';
          break;
        default:
          if (!import.meta.env.DEV) {
            window.location.replace(emptyPage);
          }
          break;
      }
    }
    bodyDom.className = themeClass;
    // 优先取轮播区第一条稿件图片，否则取封面图
    if (mCoverImg || mCoverImg1) {
      headerImage.value = mCoverImg || mCoverImg1;
    }
    // 判断是否有子栏目
    if (res.channels && res.channels.length) {
      topicChannels.value = res.channels.map((item) => ({
        id: item.id,
        name: item.name,
        topicId: item.topicid,
      }));
    } else {
      topicChannels.value = [];
    }
  } catch (e) {
    if (!import.meta.env.DEV) {
      window.location.replace(emptyPage);
    }
  }
};
const isSticky = ref(false);
provide('isSticky', isSticky);
provide('topicChannels', topicChannels);
onMounted(() => {
  const { year, month, date, id, siteId } = getUrlQuery();
  if (year && month && date && id && siteId) {
    topicParams.year = year;
    topicParams.month = month;
    topicParams.date = date;
    topicParams.topicId = id;
    getTopicDetail();
    fetchAddReadCountByLog(id, 6);
  }
  initYoumeng();
});

const mainContainerRef = ref();
const { y } = useScroll(mainContainerRef, {
  behavior: 'smooth',
});
const scrollToTop = () => {
  y.value = 0;
};
</script>

<template>
  <section ref="mainContainerRef" class="main-container">
    <img
      ref="headerImageRef"
      :src="headerImage"
      :alt="topicTitle"
      class="header-image"
    />
    <topic-article-list
      v-if="topicChannels?.length"
      :topic-params="topicParams"
      :has-child="hasChild"
    ></topic-article-list>
    <topic-article-list
      v-if="topicChannels && !topicChannels.length"
      :topic-params="topicParams"
      :has-child="hasChild"
    ></topic-article-list>
    <back-to-top @back-to-top="scrollToTop"></back-to-top>
  </section>
</template>

<style lang="scss" scoped>
.main-container {
  width: v-bind(containerwidth);
  height: 100vh;
  margin: 0 auto;
  overflow-y: auto;
  background: var(--background);

  .header-image {
    width: 100%;
    height: v-bind('headerImageHeight');
  }
}
</style>
